import {
  type DeterministicColor,
  getDeterministicColorFromId,
} from "@/lib/utils/deterministic-color";
import { cn } from "@/lib/utils/cn";
import type { HTMLAttributes } from "react";

export type IncidentTypeBadgeVariant = DeterministicColor;

export const incidentTypeBadgeVariantClassNames: Record<
  IncidentTypeBadgeVariant,
  string
> = {
  blue: "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-400/30 dark:bg-blue-500/15 dark:text-blue-300",
  green:
    "border-teal-200 bg-teal-50 text-teal-700 dark:border-teal-400/30 dark:bg-teal-500/15 dark:text-teal-300",
  orange:
    "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-400/30 dark:bg-orange-500/15 dark:text-orange-300",
  purple:
    "border-purple-200 bg-purple-50 text-purple-700 dark:border-purple-400/30 dark:bg-purple-500/15 dark:text-purple-300",
  red: "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-400/30 dark:bg-rose-500/15 dark:text-rose-300",
  yellow:
    "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-400/30 dark:bg-amber-500/15 dark:text-amber-300",
};

export const getIncidentTypeBadgeVariantFromId = (
  id: string,
): IncidentTypeBadgeVariant =>
  getDeterministicColorFromId(id, { omit: ["red"] });

type IncidentTypeBadgeProps = HTMLAttributes<HTMLDivElement> & {
  variant: IncidentTypeBadgeVariant;
};

export function IncidentTypeBadge({
  className,
  variant,
  ...props
}: IncidentTypeBadgeProps) {
  return (
    <div
      className={cn(
        "inline-flex h-[17px] shrink-0 cursor-pointer items-center justify-center gap-1 overflow-hidden rounded-lg border px-1.5 py-0 text-[10px] leading-[15px] font-medium whitespace-nowrap transition-colors",
        incidentTypeBadgeVariantClassNames[variant],
        className,
      )}
      {...props}
    />
  );
}
